import axios from "axios";

export default class AddToCart
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-add-to-cart'
    };
    
    this.add_to_cart = document.querySelector(`[${this.settings.main}]`);
    
    if (!this.add_to_cart) return;
    
    return true;
  }
  
  setEvents()
  {
    this.add_to_cart.addEventListener('click', (e) => {
      const product_id = e.target.getAttribute(this.settings.main);
  
      axios.get('?add-to-list=' + product_id)
        .then(function (response) {
  
          console.log(response.data)
          
          if (response.data == 400) {
            const popup = document.querySelector('[data-product-cart-added]');
            popup.addClass('active');
  
            setTimeout(() => {
              popup.removeClass('active');
            }, 3000);
          } else {
            const popup = document.querySelector('[data-product-cart-add]');
            const basketCounter = document.querySelector('[data-counter-basket]');
  
            if (!basketCounter.hasClass('active')) {
              basketCounter.addClass('active')
            }
  
            basketCounter.setAttribute('data-counter-basket', response.data);
            popup.addClass('active');
  
            setTimeout(() => {
              popup.removeClass('active');
            }, 3000);
 
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }
}
